import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { RequestResponse } from '../model/dto/RequestResponse';
import { HiddenMenuDto } from '../model/dto/HiddenMenuDto';
import { HiddenMenu } from '../model/HiddenMenu';

@Injectable()
export class HiddenMenuFacade {
  private _urlBase: string;
  private _httpClient: HttpClient;

  constructor(http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
    this._urlBase = baseUrl;
    this._httpClient = http;
  }

  GetResume(): Observable<RequestResponse<HiddenMenuDto[]>> {
    return this._httpClient.get<any>(this._urlBase + 'api/HiddenMenu/Resume');
  }

  PostUpdate(items: HiddenMenu[]): Observable<RequestResponse<number>> {
    return this._httpClient.post<any>(this._urlBase + 'api/HiddenMenu', items);
  }

}
